import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const getApplicantInfo = async () => {
  const formStore = useFormStore()
  const { requestNumberToSecurityDeposit } = formStore.form.values
  if (!requestNumberToSecurityDeposit) return
  try {
    const result = await apiHelperService.get(
      `/api/requestmaster/get/${requestNumberToSecurityDeposit}`
    )
    if (result) {
      const { englishApplicantName = '', arabicApplicantName = '' } = result
      formStore.draft = {
        ...formStore.draft,
        englishApplicantName,
        arabicApplicantName
      }
      getApplicantInfo()
    }
  } catch (error) {
    console.error('getApplicantInfo', error)
  }
}

const validateRequest = async () => {
  const formStore = useFormStore()
  const { requestNumberToSecurityDeposit } = formStore.form.values
  if (!requestNumberToSecurityDeposit) return
  try {
    const params = {
      refRequestNumber: requestNumberToSecurityDeposit
    }
    const result = await apiHelperService.get('/api/requestmaster/validateSecurityDepositRequest', {
      params
    })
    if (result) {
      formStore.draft.request.paymentMethodId = result.paymentMethodId
      getApplicantInfo()
      return true
    }
  } catch (error) {
    console.error('validateRequest', error)
    return false
  }
}

export default async function () {
  validateRequest()
  return true
}
